import React from 'react';
import './PseudoPageTitle.less';

export const PseudoPageTitle = ({text}) => {
	return <h1 className="pseudo-page-title">{text}</h1>
}
